if (
// @ts-expect-error $quartzConfigVal's types can't be narrowed, so any app-only config fields present as type errors
$quartzConfigVal('logFetchErrors') !== false) {
  const {
    configureLogfetchErrors
  } =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('../internal/logfetch-error-monitoring');
  const config =
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('../internal/quartz-config-for-app');
  configureLogfetchErrors(config.logFetchErrors || {});
}